import { render, staticRenderFns } from "./TaskRoundedDialog.vue?vue&type=template&id=0ec319aa&scoped=true&"
import script from "./TaskRoundedDialog.vue?vue&type=script&lang=ts&"
export * from "./TaskRoundedDialog.vue?vue&type=script&lang=ts&"
import style0 from "./TaskRoundedDialog.vue?vue&type=style&index=0&id=0ec319aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec319aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
